import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import ArtistService from '../../services/artistService';
import * as textUtils from '../../utils/textUtils';
import * as browserCheck from '../../utils/browserCheck.js';
import ToastrService from '../../services/toastrService';
import urls from '../../constants/urls';
import { Redirect } from 'react-router-dom';
import settings from '../../constants/settings.js';

class EditChatToMe extends React.Component {
    constructor(props, context) {
        super(props, context);      
        this.initialise = this.initialise.bind(this);
        this.updateChatSettings = this.updateChatSettings.bind(this);   
        this.updateField = this.updateField.bind(this);   
        this.enableChatFromOptions = {
            All: 'Anyone',
            PluggedInto: 'Users I am plugged into'
        };
        this.state = {
            profile: this.props.profile,
            loading: false,
            EnableComments: false,
            EnableCommentsFrom: null,
            CommentsRequireApproval: false,
            EnableMessagesFrom: false,
            EmailNewComment: false,
            EmailNewMessage: false
        };
    }

    componentWillMount() {
        this.initialise();
    }

    componentDidMount() { 
        window.componentHandler.upgradeDom();  
        const {getmdlSelect} = require('../../scripts/getmdl-select.js');
        getmdlSelect.init('#divCreateProfile .getmdl-select');   
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
            }, this.initialise);
        }
    }

    componentDidUpdate(prevProps, prevState) {

    }

    initialise() {
        this.setState({ loading: true, error: null });        
        this.props.actions.getChatSettings(this.state.profile.ID)
            .then(chatSettings => {
                this.setState({ loading: false, ...chatSettings });
            })
            .catch(error => this.setState({ loading: false }));
    }

    updateChatSettings(event) {
        event.preventDefault();
        this.setState({ error: null });
        const chatSettings = {
            EnableComments: this.state.EnableComments,
            EnableCommentsFrom: this.state.EnableCommentsFrom,
            CommentsRequireApproval: this.state.CommentsRequireApproval,
            EnableMessagesFrom: this.state.EnableMessagesFrom,
            EmailNewComment: this.state.EmailNewComment,
            EmailNewMessage: this.state.EmailNewMessage
        };            
        this.props.actions.updateChatSettings(this.state.profile.ID, chatSettings)
        .then(updatedChatSettings => {
            const toastrService = new ToastrService();
            toastrService.showSuccess('', 'The changes have been saved successfully');
            this.setState({
                ...updatedChatSettings,
                error: null
            });
        }) 
        .catch(error => {
            this.setState({ error: error.message });
        });
    }

    updateField(event) {
        const name = (event.target.name || event.target.attributes['name'].value);
        let value;
        if(event.target.className === 'mdl-checkbox__input') {
            value = event.target.checked;
        }
        else if(event.target.className === 'mdl-radio__button') {
            let checked = event.target.checked;
            value = event.target.dataset.val;
        }
        else if (event.target.className === 'mdl-menu__item') {
            value = event.target.dataset.val;// event.target.innerText;
        }  
        else {
            value = event.target.value;
        }
        const state = {...this.state};
        state[name] = value;
        this.setState(state);
    }

    render() {
        return (
            <div id="divCreateProfile">       
                <form id="frmEditChatToMe" onSubmit={this.updateChatSettings}> 
                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />    
                    <h3 className="subsection">Edit Comment Preferences</h3>   
                    <label className={`mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect is-upgraded ${this.state.EnableComments ? 'is-checked' : ''}`} htmlFor="EnableComments">
                        <input type="checkbox" id="EnableComments" name="EnableComments" className="mdl-checkbox__input" checked={this.state.EnableComments} onChange={this.updateField} />
                        <span className="mdl-checkbox__label">Enable comments</span>
                    </label>
                    <div className="radio">
                        <p id="pEnableCommentsFrom">Enable comments from:
                            <br />
                            {
                                Object.keys(this.enableChatFromOptions).map(option =>
                                    <label key={option} className={`mdl-radio mdl-js-radio mdl-js-ripple-effect is-upgraded ${!this.state.EnableComments ? 'is-disabled' : ''} ${this.state.EnableCommentsFrom === option ? 'is-checked' : ''}`} htmlFor={`EnableCommentsFrom_${option}`} style={{display: 'block'}}>
                                        <input type="radio" id={`EnableCommentsFrom_${option}`} data-val={option} name="EnableCommentsFrom" className="mdl-radio__button" disabled={!this.state.EnableComments} checked={this.state.EnableCommentsFrom === option} onChange={this.updateField} />
                                        <span className="mdl-radio__label">{this.enableChatFromOptions[option]}</span>
                                    </label>
                                )
                            }
                        </p>
                    </div>
                    <div id="pCommentsRequireApproval" className="checkbox">
                        <label className={`mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect is-upgraded ${!this.state.EnableComments ? 'is-disabled' : ''} ${this.state.CommentsRequireApproval ? 'is-checked' : ''}`} htmlFor="CommentsRequireApproval">
                            <input type="checkbox" id="CommentsRequireApproval" name="CommentsRequireApproval" className="mdl-checkbox__input" disabled={!this.state.EnableComments} checked={this.state.CommentsRequireApproval} onChange={this.updateField} />
                            <span className="mdl-checkbox__label">I want to approve comments before they are displayed</span>
                        </label>
                    </div>
                    <div id="pEmailComments" className="checkbox">
                        <label className={`mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect is-upgraded ${!this.state.EnableComments ? 'is-disabled' : ''} ${this.state.EnableComments ? 'is-checked' : ''}`} htmlFor="EmailNewComment">
                            <input type="checkbox" id="EmailNewComment" name="EmailNewComment" className="mdl-checkbox__input" disabled={!this.state.EnableComments} checked={this.state.EmailNewComment} onChange={this.updateField} />
                            <span className="mdl-checkbox__label">Email me new comments</span>
                        </label>
                    </div>
                    <br />
                    <h3 className="subsection">Edit Message Preferences</h3>
                    <div className="radio">
                        <p id="pEnableCommentsFrom">Enable private messages from:
                            <br />
                            {
                                Object.keys(this.enableChatFromOptions).map(option =>
                                    <label key={option} className={`mdl-radio mdl-js-radio mdl-js-ripple-effect is-upgraded ${this.state.EnableMessagesFrom === option ? 'is-checked' : ''}`} htmlFor={`EnableMessagesFrom_${option}`} style={{display: 'block'}}>
                                        <input type="radio" id={`EnableMessagesFrom_${option}`} data-val={option} name="EnableMessagesFrom" className="mdl-radio__button" checked={this.state.EnableMessagesFrom === option} onChange={this.updateField} />
                                        <span className="mdl-radio__label">{this.enableChatFromOptions[option]}</span>
                                    </label>
                                )
                            }
                        </p>
                    </div>
                    <div id="pEmailMessages" className="checkbox">
                        <label className={`mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect is-upgraded ${this.state.EmailNewMessage ? 'is-checked' : ''}`} htmlFor="EmailNewMessage">
                            <input type="checkbox" id="EmailNewMessage" name="EmailNewMessage" className="mdl-checkbox__input" checked={this.state.EmailNewMessage} onChange={this.updateField} />
                            <span className="mdl-checkbox__label">Email me new private messages</span>
                        </label>
                    </div>
                    <br />
                    <br />
                    <input type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" value="SAVE" onClick={this.updateChatSettings} />                                  
                </form>
            </div>                 
        );
    }
}

EditChatToMe.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default EditChatToMe;